import { render, staticRenderFns } from "./advertCenter.vue?vue&type=template&id=85dd604e&scoped=true"
import script from "./advertCenter.vue?vue&type=script&lang=js"
export * from "./advertCenter.vue?vue&type=script&lang=js"
import style0 from "./advertCenter.vue?vue&type=style&index=0&id=85dd604e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd604e",
  null
  
)

export default component.exports